export default {"src":"/_next/static/media/ai-readiness.ee20528e.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};